<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row">
        <div class="col-12">
          <q-card>
            <q-card-section class="bg-primary text-white">
              <div class="row items-center">
                <div style="display: inline-block" class="text-h6">
                  Questions
                </div>
                <q-btn
                  class="q-ml-md"
                  color="white"
                  text-color="white"
                  icon="mdi-plus"
                  flat
                  @click="newDialog = true"
                ></q-btn>
                <q-space />
                <q-input
                  style="max-width: 70%"
                  dark
                  standout
                  v-model="search"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"> </q-icon>
                  </template>
                </q-input>
              </div>
            </q-card-section>

            <q-separator />
            <q-card-section class="q-pa-none">
              <div v-if="questions">
                <div class="row">
                  <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                  <div
                    class="col-12 mt-0 pt-0"
                    style="height: calc(100vh - 200px) !important"
                  >
                    <datatable
                      :filter="search"
                      :flat="true"
                      :data="questions"
                      :columns="columns"
                      @rowDoubleClick="handleDoubleClick"
                    >
                    </datatable>
                  </div>
                </div>
              </div>
            </q-card-section>
            <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
          </q-card>
        </div>
      </div>
    </div>

    <q-dialog v-model="newDialog" seamless>
      <q-card
        v-if="newDialog"
        tile
        style="width: 600px !important; max-width: 600px"
      >
        <q-card-section class="bg-accent text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Question
            </div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <questionForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-plus"
                label="Create"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" seamless>
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 600px !important; max-width: 600px"
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Question</div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <questionForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-content-save-all"
                label="Save"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import questionForm from "@/components/questions/questionForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    questionForm,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      questions: "questions/list",
      questionsLoading: "questions/listLoading",
    }),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "label",
        label: "Label",
        align: "left",
        field: "message",
        sortable: true,
      },
      {
        name: "outcome",
        label: "Outcome",
        align: "left",
        field: "outcomes_id",
        sortable: true,
      },
      {
        name: "category",
        label: "Category",
        align: "left",
        field: "category",
        sortable: true,
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        field: "status",
        sortable: true,
      },
      {
        name: "created_by",
        label: "Created By",
        align: "left",
        field: "created_by",
        sortable: true,
      },
      {
        name: "updated_by",
        label: "Updated By",
        align: "left",
        field: "updated_by",
        sortable: true,
      },
      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: (val) =>
          val != null
            ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true,
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: (val) =>
          val != null
            ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true,
      },
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,
  }),
  beforeCreate() {
    this.$store.dispatch("questions/loadAll");
  },
  mounted() {},
  methods: {
    handleDoubleClick(row) {
      this.viewFormData = row;
      this.viewDetailsDialog = true;
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
